import Vue from "vue";
import Router from "vue-router";
import {
	themeRouteProps,
	ThemeRender
} from "vue-multi-theme";

Vue.use(Router);

import Home from "@/views/home/index/index.vue";
import About from "@/views/home/about/index.vue";
import Column from "@/views/home/column/index.vue";
import Custom from "@/views/home/custom/index.vue";
import Student from "@/views/home/student/index.vue";
import Free from "@/views/home/free/index.vue";
import Honor from "@/views/home/honor/index.vue";
import Vip from "@/views/home/vip/index.vue";

import VideoPlay from "@/views/videoPlay/index/index.vue";
import ColumnDetail from "@/views/column/detail/index.vue";
import CourseDetail from "@/views/course/detail/index.vue";
import CustomDetail from "@/views/custom/detail/index.vue";
import StudentList from "@/views/student/list/index.vue";
import StudentDetail from "@/views/student/detail/index.vue";

import MyOrder from "@/views/management/myOrder/index.vue";
import MyCourse from "@/views/management/myCourse/index.vue";
import MyCollect from "@/views/management/myCollect/index.vue";
import MyPartner from "@/views/management/myPartner/index.vue";

// 路由
export const router = [{
		path: "/",
		name: "home",
		component: ThemeRender,
		props: themeRouteProps("Home", Home),
	},
	{
		path: "/about",
		name: "about",
		component: ThemeRender,
		props: themeRouteProps("About", About),
	},
	{
		path: "/column",
		name: "column",
		component: ThemeRender,
		props: themeRouteProps("Column", Column),
	},
	{
		path: "/custom",
		name: "custom",
		component: ThemeRender,
		props: themeRouteProps("Custom", Custom),
	},
	{
		path: "/student",
		name: "student",
		component: ThemeRender,
		props: themeRouteProps("Student", Student),
	},
	{
		path: "/free",
		name: "free",
		component: ThemeRender,
		props: themeRouteProps("free", Free),
	},
	{
		path: "/honor",
		name: "honor",
		component: ThemeRender,
		props: themeRouteProps("Honor", Honor),
	},
	{
		path: "/vip",
		name: "vip",
		component: ThemeRender,
		props: themeRouteProps("Vip", Vip),
	},
	{
		path: "/videoPlay",
		name: "videoPlay",
		component: ThemeRender,
		props: themeRouteProps("VideoPlay", VideoPlay),
	},
	{
		path: "/columnDetail",
		name: "columnDetail",
		component: ThemeRender,
		props: themeRouteProps("ColumnDetail", ColumnDetail),
	},
	{
		path: "/courseDetail",
		name: "courseDetail",
		component: ThemeRender,
		props: themeRouteProps("CourseDetail", CourseDetail),
	},
	{
		path: "/customDetail",
		name: "customDetail",
		component: ThemeRender,
		props: themeRouteProps("CustomDetail", CustomDetail),
	},
	{
		path: "/studentList",
		name: "studentList",
		component: ThemeRender,
		props: themeRouteProps("StudentList", StudentList),
	},
	{
		path: "/studentDetail",
		name: "studentDetail",
		component: ThemeRender,
		props: themeRouteProps("StudentDetail", StudentDetail),
	},
	{
		path: "/myOrder",
		name: "myOrder",
		component: ThemeRender,
		props: themeRouteProps("MyOrder", MyOrder),
	},
	{
		path: "/myCourse",
		name: "myCourse",
		component: ThemeRender,
		props: themeRouteProps("MyCourse", MyCourse),
	},
	{
		path: "/myCollect",
		name: "myCollect",
		component: ThemeRender,
		props: themeRouteProps("MyCollect", MyCollect),
	},
	{
		path: "/myPartner",
		name: "myPartner",
		component: ThemeRender,
		props: themeRouteProps("MyPartner", MyPartner),
	},
];

// 防止连续点击多次路由报错
let originPush = Router.prototype.push; //备份原push方法
Router.prototype.push = function(location, resolve, reject) {
	// return routerPush.call(this, location).catch(err => err)
	if (resolve && reject) {
		//如果传了回调函数，直接使用
		originPush.call(this, location, resolve, reject);
	} else {
		//如果没有传回调函数，手动添加
		originPush.call(
			this,
			location,
			() => {},
			() => {}
		);
	}
};

// 重写路由
export default new Router({
	mode: "history", // history去掉url中的#,但重定向有问题
	base: "/",
	routes: router,
	scrollBehavior: () => ({
		y: 0,
	}),
});